import { useDispatch } from "react-redux";
import { axiosNoAuth } from "../../config/axiosInstances";
import { SET_USER_ENGAGEMENT_DATA } from "./types";
import axios from "axios";

export function loginWithLinkedin(
  code,
  redirect_uri,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/signup/linkedin",
        {
          code,
          redirect_uri,
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function manualLoginPhase1(name, email, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/signup/email",
        {
          email,
          name,
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function manualLoginPhase2(
  email,
  current_role,
  current_role_detail,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        " https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/user/submit_details",
        {
          email,
          current_role,
          current_role_detail,
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getUserEngagement(
  unique_certificate_id,
  id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/engagements",
        {
          params: {
            unique_certificate_id,
            id
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function toggleLikeCount(
  email,
  unique_certificate_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/engagements/like/toggle",
        {
          email,
          unique_certificate_id,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function addUserComment(
  email,
  comment_text,
  unique_certificate_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/engagements/comment/add",
        {
          email,
          comment_text,
          unique_certificate_id,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function trackUser(
  email,
  unique_certificate_id,
  certificate_owner_email,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/verification/track",
        {
          email,
          unique_certificate_id,
          certificate_owner_email,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function editUserDetails(
  email,
  current_role,
  current_role_detail,
  phone_number,
  name,
  id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/user/edit_profile",
        {
          email,
          current_role,
          current_role_detail,
          phone_number,
          name,
          id,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function setRequestData(
  email,
  request_type,
  hiring_for_role,
  phone_number,
  reason_of_request,
  unique_certificate_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/user/request/new",
        {
          email,
          request_type,
          hiring_for_role,
          phone_number,
          reason_of_request,
          unique_certificate_id,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function checkRequestData(
  email,
  unique_certificate_id,
  request_type,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/user/request/check",
        {
          email,
          request_type,
          unique_certificate_id,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getLinkedInSuggestions(email, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/user/suggestions/linkedin_profiles",
        {
          params: {
            email,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function updateCvFile(email, cv_file, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("cv_file", cv_file);

      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/user/update/cv",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          maxBodyLength: Infinity,
        }
      );
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function updateLinkedin(
  email,
  linkedin_profile_url,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/user/update/linkedin",
        {
          email,
          linkedin_profile_url,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getRecommendedSkills(
  subject_name,
  n,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://ninjacurate.learntube.ai/similar_skills_list",
        { subject_name, n }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getRelatedJobs(subject_name, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/user/suggestions/jobs",
        { params: { subject_name } }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getRadarData(
  unique_certificate_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:nU-vPWEG/user/analytics/radar",
        {
          params: {
            unique_certificate_id,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getCertifiedDetails(
  certified_user_skill_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        "https://certified-new.learntube.ai/certified_user_skill",
        {
          params: {
            certified_user_skill_id,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getCertifiedToken(
  certified_user_skill_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axios.get(
        "https://certified-new.learntube.ai/certified_user_skill/wa_token_test",
        {
          headers: {
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZXJ0aWZpZWRfdXNlcl9za2lsbF9pZCI6MTE4NTExMywibmFtZSI6IkthcnRoaWsgQSBNIiwicGhvbmVfbnVtYmVyIjoiKzkxOTQ0ODU3NTEzMSIsImVtYWlsIjoiZ2V0a2FyMTI4QGdtYWlsLmNvbSIsInBhc3N3b3JkIjoiZ2V0a2FyMTI4QGdtYWlsLmNvbSJ9.8zxD4X_9B-E2lLvvQEZ2tsMAhozVE4e2CMwgqrBoLtQ`,
          },
          params: {
            certified_user_skill_id,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function linkedInPostTemplate(
  subject_name,
  score_level,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:_bpjPAc1/linkedin_post_copy/generate",
        {
          params: {
            subject_name,
            score_level,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}


export function shareLinkedInPost(
 code, redirect_uri, post_title, post_desc,email ,source,extra_details, post_comment, image_url, successCallback,errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:UpsZVD6L/linkedin/share_image_v2",
        {
                code,
                redirect_uri,
                post_title,
                post_desc,
                post_comment,
                post_url: '',
                image_url,
                type: 'certificate',
                email,
                source,
                extra_details
            }
       
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}




